// class that implements a custom 'initializer', a 'switch language' handler for translator
// and any other method for handling language settings

import {ITranslatorManager} from "libComm";
import {TranslateService} from "@ngx-translate/core";

export class EURTranslatorManager implements ITranslatorManager
{
	constructor()
	{
	}

	// implement application logic for initialising the translator
	public initTranslator(ts: TranslateService): void
	{
		// set default language (has to be 'en'), used when other languages are note available
		ts.setDefaultLang('en');

		//ts.addLangs(['en', 'it']);  // set available translation languages
		// console.log("custom TranslatorSetup applied !");
	}

	// handler called when requested for changing UI language
	switchLangHandler(ts: TranslateService, langId: string)
	{
		ts.use(langId);

		// store last used language into local storage
		localStorage.setItem('selectedLanguage', langId);
	}
}
